
import "./gradientLine.scss"

const GradientLine = () => {

    return(
        <div className="container-linea-degradada"> 
            <div className="linea-degradada mt-3"></div>
        </div>
    )
}

export default GradientLine;